import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    className: 'image-marquee',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const marquees = gsap.utils.toArray( '[data-component="image-marquee"] .js-image-marquee-slider' );
      marquees.forEach( ( marquee ) => {
        gsap.to( marquee, {
          x: '-150vw',
          ease: 'power1.inOut',
          scrollTrigger: {
            trigger: marquee,
            scrub: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
